import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { SystemOverview } from './components/SystemOverview';
export function App() {
  return <main className="w-full bg-[#061A21]" data-id="element-0" data-mp="3k8t6ezu3qzr6">
      <Hero data-id="element-1" data-mp="3f9yhrh9gegz5" />
      <Testimonials data-id="element-2" data-mp="3fa850x346a15" />
      <PainPoints data-id="element-3" data-mp="3fb16pjn7u9cf" />
      <SystemOverview data-id="element-4" data-mp="3f8eyriwexrto" />
    </main>;
}